import { z } from "zod";

export const clientPlatformSchema = z.object({
  name: z
    .string()
    .min(2, "Nome deve ter no mínimo 2 caracteres")
    .max(32, "Nome deve ter no máximo 32 caracteres"),
  subdomain: z.string().optional().nullable(),
  customURL: z
    .string()
    .url("URL inválida")
    .optional()
    .nullable()
    .or(z.literal("")),
  logo: z
    .string()
    .url("URL da logo inválida")
    .optional()
    .nullable()
    .or(z.literal("")),
  primaryColor: z.string().optional().nullable(),
  isActive: z.boolean().optional(),
  nativeClientPlatformPlanID: z.number().int().optional().nullable(),
});
